import { injectIntl } from "react-intl";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createSelector } from 'reselect';

import {
    create, errorReset, get, getDischargeStatusCodes, getGrouperConfigs, getMethodTypes, getMultiPrecedences, getPayMethods, getPaySources, getProviderRoleCriteria, getRuleCriteria, getRuleTypes, resetCodesValidate, update, validate
} from '../../../store/actions/rules';
import { tiny } from '../../../store/actions/services';
import {
    createRuleSelector, selectGrouperConfigurations, selectMethodTypes,
    selectMultiprocPrecedences, selectPayMethods, selectPaySources, selectRuleTypes, selectSelectedGroups
} from "../../../store/selectors/rules";

import { selectCodeServicesTiny } from "../../../store/selectors/services";

import { feeScheduleLabelsTiny, get as getContract, getFeeschedule, isCodeServiceDrg, isFeeScheduleDrg, listFeeSchedule } from '../../../store/actions/contracts';
import { createContractedServiceSelector, createContractSelector, selectFeeScheduleLabelsTiny, selectFeeScheduleLanding } from '../../../store/selectors/contracts';

import { getFeescheduleRateLabel } from '../../../store/actions/feeScheduleItems';
import { getModifiersPayMethods, modifiersLanding } from '../../../store/actions/modifiers';
import { RULE_CRITERIA_STRING } from '../../../store/constants/contract';
import { asIsoDate } from '../../../util/date';
import RulesEditPageComponent from './RulesEditPage';
import { npiRolesLanding } from "../../../store/actions/npiRoles";
import { selectCanAccessCMS } from "../../../store/selectors/access";

const multiProcedureTemplate = {
    precedenceId: '',
    percentage: '',
}

const npiRateTemplate = {
    npi: '',
    rate: '',
    feescheduleLabelToRateXRefId: null,
    globalFeescheduleLabelToRateXRefId: null
}

const npiRoleTemplate = {
    npiRoleId: '',
    rate: '',
    feescheduleLabelToRateXRefId: null,
    globalFeescheduleLabelToRateXRefId: null
}

const modifierTemplate = {
    modifierId: null,
    payMethodId: '',
    value: ''
}

const selectionCriteriaTemplate = {
    ruleSelectionCriteriaId: null,
    equator: '',
    value: '',
    startsAt: '',
    endsAt: ''
}

const getDefaultDateRange = (startDate, endDate) => {
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);

    if(startDate && endDate) {
        return {
            startdate: startDate.slice(0, 10),
            enddate: endDate.slice(0, 10),
            relativeFilter: 'custom',
        };
    }
    return {
        startdate: today.toISOString().slice(0, 10),
        enddate: tomorrow.toISOString().slice(0, 10),
        relativeFilter: 'custom',
    };
};

let paySplit = {
    "payMethodId":'',
    "payValue":"",
    "equator":"",
    "value":"",
    "startsAt":"",
    "endsAt":"",
    "feeScheduleId": null,
    "feeScheduleName": '',
    "feescheduleLabelToRateXRefId": null,
    "rateLabels": [],
    // Global Fee Schedule fields
    "globalFeeScheduleId": null,
    "globalFeescheduleLabelToRateXRefId": null,
    "globalFeeScheduleGPCI": null,
    "globalFeeScheduleState": null,
    "globalFeeScheduleLocality": null,
    // UI-only fields
    "requiresGlobalConfig": false,
    "selectedRateType": null,
    "selectedState": null,
    "selectedLocality": null,
    "selectedGpci": null,
    "global_schedule_rate_column": null,
    "dateRange": getDefaultDateRange(null, null),
}
const def_rulePaymentFeeScheduleXRef = [
    {
        feeScheduleId: null,
        feeScheduleName: '',
        fromDate: null,
        toDate: null,
        feescheduleLabelToRateXRefId: null,
        payMethodId: null,
        payValue: null,
        dosMaxRate: null,
        rateLabels: [],
        // Anesthesia fields
        useMinutesPerUnit: false,
        minutesPerUnit: 15,
        // Global Fee Schedule fields
        globalFeeScheduleId: null,
        globalFeescheduleLabelToRateXRefId: null,
        globalFeeScheduleGPCI: null,
        globalFeeScheduleState: null,
        globalFeeScheduleLocality: null,
        // UI-only fields for global config
        requiresGlobalConfig: false,
        selectedRateType: null,
        selectedState: null,
        selectedLocality: null,
        selectedGpci: null,
        global_schedule_rate_column: null,
        dateRange: getDefaultDateRange(null, null),
        payValuePercentage: null,                      
        avgLengthOfStay: null
    }
];

// Default template for fee schedule groups (new schema)
const def_ruleFeeScheduleGroupXref = [{
    id: null,
    feeScheduleId: null,
    feeScheduleName: '',
    feeSchedule: null,
    feescheduleLabelToRateXRefId: null,
    globalFeeScheduleId: null,
    globalFeescheduleLabelToRateXRefId: null,
    globalFeeSchedule: null,
    globalFeescheduleState: null,
    globalFeescheduleLocality: null,
    globalFeescheduleGPCI: null,
    baseRate: null,
    rateLabels: [],
    requiresGlobalConfig: false,
    selectedState: null,
    selectedLocality: null,
    selectedGpci: null,
    useCustomDates: false,
    customDateRange: null,
    // Default payment item for non-split scenarios (1 item per group)
    rulePaymentFeeScheduleXRef: [{
        id: null,
        payMethodId: null,
        payValue: null,
        dosMaxRate: null,
        feeScheduleXrefId: null
    }],
    // Default split item for split scenarios (can have multiple)
    ruleSplitPaymentXRef: [{
        id: null,
        payMethodId: null,
        payValue: null,
        equator: '',
        value: '',
        startsAt: '',
        endsAt: '',
        feeScheduleXrefId: null
    }]
}];

const def_lesserOfConfiguration = [
    {
        lesserOfType: null,
        percentage: null,
        feeScheduleId: null,
        feeScheduleName: '',
        EffectiveFrom: null,
        EffectiveTo: null,
        feescheduleLabelToRateXRefId: null,
        rateLabels: [],
        // Global Fee Schedule fields
        globalFeeScheduleId: null,
        globalFeescheduleLabelToRateXRefId: null,
        globalFeeScheduleGPCI: null,
        globalFeeScheduleState: null,
        globalFeeScheduleLocality: null,
        // UI-only fields for global config
        requiresGlobalConfig: false,
        selectedRateType: null,
        selectedState: null,
        selectedLocality: null,
        selectedGpci: null,
        global_schedule_rate_column: null
    }
];

const def_providerRolePaymentCriteriaXref = [{
    providerRoleSelectionCriteriaId: null,
    type: null,
    equator: '',
    value: ''
}];

const def_providerRolePaymentGroupXref = [{
    id: null,
    payMethodId: null,
    payValue: null,
    feeScheduleId: null,
    feeScheduleName: '',
    feeSchedule: null,
    feescheduleLabelToRateXRefId: null,
    globalFeeScheduleId: null,
    globalFeescheduleLabelToRateXRefId: null,
    globalFeeSchedule: null,
    globalFeescheduleState: null,
    globalFeescheduleLocality: null,
    globalFeescheduleGPCI: null,
    baseRate: null,
    rateLabels: [],
    requiresGlobalConfig: false,
    selectedState: null,
    selectedLocality: null,
    selectedGpci: null,
    useGlobalFeeSchedules: false,
    global_schedule_rate_column: null,
    dateRange: null,
    providerRolePaymentCriteriaXref: def_providerRolePaymentCriteriaXref,
}];

export const RulesEditPage = connect(
    () => {
        const selectContractId = (state, props) => props.match.params.contractId;
        const selectViewOnly = (state, props) => props.match.params?.viewOnly;
        const isCopyRule = window.location.pathname.includes('/copy/');

        const selectContract = createContractSelector(selectContractId) as any;
        const selectRuleId : any = (state, props) => props.match.params.ruleId;
        const selectServiceId = (state, props) => props.match.params.serviceId;

        const selectMode = (state, props) => props.match.params.ruleId === 'new' ? 'create' : 'edit';
        const selectModifiers = (state) => state.modifiers.data;
        const selectModifersPayMethod = (state) => state.modifiers.payMethods;
        const selectRuleCriteria = (state) => state.rules.criteria;
        const selectProviderRoleCriteria = (state) => state.rules.providerRoleCriteria;

        const selectRule = createRuleSelector(selectRuleId) as any;

        const selectViewOnlyWithAccess = createSelector(
            selectViewOnly,
            selectCanAccessCMS,
            (viewOnly, cmsAccess) => {
                if (cmsAccess === false) {
                    return true;
                }
                return viewOnly || false;
            }
        ) as any;

        const selectSelectedService = createContractedServiceSelector(selectContractId, selectServiceId);

        const serviceType = createSelector(
            selectSelectedService,
            (service) => {
                if (service && service.serviceType) {
                    return service.serviceType.name;
                }
            }
        ) as any;

        const selectFilteredCodeServices = createSelector(
            selectCodeServicesTiny,
            selectSelectedService,
            (codeServices, service) => {
                if (codeServices && service && service.serviceType) {
                    return codeServices.filter(x => x.serviceType === service.serviceType.name).sort((a, b) => a.name.localeCompare(b.name))
                }
                return [];
            }
        ) as any;

        const selectSortedFeeSchedule = createSelector(
            selectFeeScheduleLanding,
            (feeSchedule) => {
                return feeSchedule.sort((a, b) => a.name.localeCompare(b.name))
            }
        ) as any;

        const selectSortedFeeScheduleLabels = createSelector(
            selectFeeScheduleLabelsTiny,
            (labels) => {
                if (!labels || labels.length === 0) {
                    return [];
                }
                return labels.sort((a, b) => a.label.localeCompare(b.label));
            }
        ) as any;

        const getDefaultMultiProcedurePercents = (rule) => {
            if (rule && rule.multiProcedurePercentageToRuleXref?.length > 0) {
                return rule.multiProcedurePercentageToRuleXref;
            }
            return [multiProcedureTemplate];
        }

        const getDefaultRuleToNpirateXref = (rule) => {
            if (rule && rule.ruleToNpirateXref?.length > 0) {
                return rule.ruleToNpirateXref.map(entry => ({
                    ...entry,
                    feescheduleLabelToRateXRefId: entry.feescheduleLabelToRateXRefId || null,
                    globalFeescheduleLabelToRateXRefId: entry.globalFeescheduleLabelToRateXRefId || null
                }));
            }
            return [npiRateTemplate];
        }

        const getDefaultRuleToNpiroleXref = (rule) => {
            if (rule && rule.ruleToNpiroleXref?.length > 0) {
                return rule.ruleToNpiroleXref.map(entry => ({
                    ...entry,
                    feescheduleLabelToRateXRefId: entry.feescheduleLabelToRateXRefId || null,
                    globalFeescheduleLabelToRateXRefId: entry.globalFeescheduleLabelToRateXRefId || null
                }));
            }
            return [npiRoleTemplate];
        }

        const getDefaultModifierXref = (rule, modifiers) => {
            if (rule && rule.ruleToModifierXref?.length > 0) {
                return rule.ruleToModifierXref.map(item => {
                    const modifier = modifiers.find(mdfr => mdfr.id === item.modifierId);
                    return {
                        modifierId: modifier ?? null,
                        payMethodId: item.payMethodId,
                        value: item.value,
                        modifierMultiProcedurePercentage: item.modifierMultiProcedurePercentage?.map(item => ({ occurance: item.occurance, value: item.value })) ?? []
                    }
                });
            }
            return [modifierTemplate];
        }

        const getDefaultSelectionCriteria = (rule, ruleCriteria) => {
            if (rule && rule.ruleSelectionCriteriaXref?.length > 0) {
                return rule.ruleSelectionCriteriaXref.map(item => {
                    const criteria = ruleCriteria.find(rc => rc.id === item.ruleSelectionCriteriaId);
                    const baseItem = {
                        ...item,
                        ruleSelectionCriteriaId: criteria,
                        type: criteria ? criteria.fieldType : RULE_CRITERIA_STRING
                    };

                    // Parse value into startsAt and endsAt for between operators
                    if (item.equator === 'alpha_between' || item.equator === 'in_between') {
                        const parts = item.value ? item.value.split('&') : ['', ''];
                        return {
                            ...baseItem,
                            startsAt: parts[0] || '',
                            endsAt: parts[1] || ''
                        };
                    }

                    return {
                        ...baseItem,
                        startsAt: '',
                        endsAt: ''
                    };
                })
            }
            return [selectionCriteriaTemplate];
        }

        const getDefaultProviderRolePaymentCriteria = (criteriaXref = [], providerRoleCriteria) => {
            if (criteriaXref?.length > 0) {
                return criteriaXref.map(item => {
                    const criteria = providerRoleCriteria.find(rc => rc.id === item.providerRoleSelectionCriteriaId);
        
                    return {
                        ...item,
                        providerRoleSelectionCriteriaId: criteria || null,
                        type: criteria ? criteria.fieldType : RULE_CRITERIA_STRING
                    };
                });
            }
        
            return def_providerRolePaymentCriteriaXref;
        };
        

        const selectInitialValues = createSelector(
            selectMode,
            selectRule,
            selectModifiers,
            selectRuleCriteria,
            selectProviderRoleCriteria,
            (mode, rule, modifiers, ruleCriteria, providerRoleCriteria) => {
                if (mode === 'edit' && rule) {
                    // Define useGlobal at the top level for use throughout the mapping
                    const useGlobal = rule.useGlobalFeeSchedules || false;
                    const useGlobalFsForLesserOf = rule.useGlobalFsForLesserOf || false;

                    const payload = {
                        id: rule.id,
                        name: isCopyRule ? `Copy - ${rule.name}` : rule.name,
                        ruleTypeId: rule.ruleTypeId,
                        methodId: rule.methodId,
                        paymethodId: rule.paymethodId,
                        payvalue: rule.payvalue,
                        // CODE SELECTION: Use globalFeeScheduleId if present, otherwise use local
                        feeScheduleId: rule.globalFeeScheduleId ? null : rule.feeScheduleId,
                        feeScheduleName: rule.globalFeeScheduleId
                            ? (rule.globalFeeSchedule?.name ?? '')
                            : (rule.feeSchedule?.name ?? ''),
                        feescheduleLabelToRateXRefId: rule.globalFeeScheduleId ? null : (rule.feescheduleLabelToRateXRefId ?? null),
                        selectedfeescheduleLabelToRateXRef: null,
                        feeSchedule: rule.feeSchedule || null,
                        codeSelectionFeeSchedule: rule.feeSchedule || null,
                        globalFeeSchedule: rule.globalFeeSchedule || null,
                        globalFeeScheduleId: rule.globalFeeScheduleId ?? null,
                        globalFeescheduleLabelToRateXRefId: rule.globalFeescheduleLabelToRateXRefId ?? null,
                        contractServiceId: rule.contractServiceId,
                        description: rule.description,
                        carveoutCodes: rule.carveoutCodes,
                        codeServiceId: rule.codeServiceId || '',
                        paySourceId: rule.paySourceId,
                        usePaidCode: rule.usePaidCode,
                        useMultiProcedurePercent: rule.useMultiProcedurePercent,
                        multiProcedurePercents: getDefaultMultiProcedurePercents(rule),
                        useNpiRate: rule.useNpiRate,
                        ruleToNpirateXref: getDefaultRuleToNpirateXref(rule),
                        useNpiRole: rule.useNpiRole,
                        ruleToNpiroleXref: getDefaultRuleToNpiroleXref(rule),
                        precedence: isCopyRule ? "" : rule.precedence,
                        payInAddition: rule.payInAddition,
                        fromDate: asIsoDate(rule.fromDate),
                        toDate: asIsoDate(rule.toDate),
                        isCircuitBreaker: rule.isCircuitBreaker,
                        lesserOf: rule.lesserOf,
                        codeSelectionType: rule.codeSelectionType,
                        grouperConfigurationId: rule.grouperConfigurationId,
                        usePaymentFeeSchedules: rule.usePaymentFeeSchedules || false,
                        useGlobalFeeSchedules: rule.useGlobalFeeSchedules || false,
                        maxRate: rule.maxRate,
                        maxRateValue: rule.maxRateValue,
                        threshold: rule.threshold,
                        thresholdValue: rule.thresholdValue,
                        applyAt: rule.applyAt,
                        useModifiers: rule.useModifiers ?? false,
                        ruleToModifierXref: getDefaultModifierXref(rule, modifiers),
                        ruleSelectionCriteriaXref: getDefaultSelectionCriteria(rule, ruleCriteria),
                        ignoreClaim: rule.ignoreClaim,
                        considerFsTc: rule.considerFsTc,
                        dosMaxRate: rule.dosMaxRate,
                        ignoreCmsConfiguration: rule.ignoreCmsConfiguration,
                        isSometimesPay: rule.isSometimesPay,
                        sometimesPayCodes: rule.sometimesPayCodes ?? '',
                        isCriteriaOperatorAnd: rule.isCriteriaOperatorAnd ?? true,
                        useSplitPayment:rule?.useSplitPayment || false,
                        payValuePercentage: rule.payValuePercentage ?? '',
                        isAlosEnabled: rule.isAlosEnabled ?? false,
                        avgLengthOfStay: rule.avgLengthOfStay ?? '',
                        useCustomPaymentDates: rule.useCustomPaymentDates ?? true,
                        ruleSplitPaymentXref:
                            rule?.ruleSplitPaymentXRef?.length > 0
                                ? rule?.ruleSplitPaymentXRef?.map((item, index) => {
                                      // Extract fee schedule from nested rate label object if not directly available
                                      // Backend returns: globalFeescheduleLabelToRateXRef.globalFeeSchedule
                                      const extractedGlobalFeeScheduleId = item.globalFeeScheduleId 
                                          || item.globalFeescheduleLabelToRateXRef?.globalFeeScheduleId 
                                          || null;
                                      const extractedGlobalFeeSchedule = item.globalFeeSchedule 
                                          || item.globalFeescheduleLabelToRateXRef?.globalFeeSchedule 
                                          || null;
                                      
                                      const baseMapping = {
                                          ...item,
                                          // Use extracted values for global fee schedule
                                          globalFeeScheduleId: extractedGlobalFeeScheduleId,
                                          globalFeeSchedule: extractedGlobalFeeSchedule,
                                          feeScheduleName: useGlobal
                                              ? (extractedGlobalFeeSchedule?.name ?? item?.feeScheduleName ?? '')
                                              : (item?.feeSchedule?.name ?? item?.feeScheduleName ?? ''),
                                          rateLabels: item.feeSchedule?.feescheduleLabelToRateXRef || extractedGlobalFeeSchedule?.globalFeescheduleLabelToRateXRef || [],
                                          feeSchedule: item.feeSchedule || null,
                                          feescheduleLabelToRateXRefId: useGlobal
                                              ? (item.globalFeescheduleLabelToRateXRefId || item.feescheduleLabelToRateXRefId || null)
                                              : (item.feescheduleLabelToRateXRefId || null),
                                          globalFeeScheduleGPCI: (item as any).globalFeescheduleGPCI || item.globalFeeScheduleGPCI || null,
                                          globalFeeScheduleState: (item as any).globalFeescheduleState || item.globalFeeScheduleState || null,
                                          globalFeeScheduleLocality: (item as any).globalFeescheduleLocality || item.globalFeeScheduleLocality || null,
                                          requiresGlobalConfig: Boolean(
                                              (item as any).globalFeescheduleState || item.globalFeeScheduleState ||
                                              (item as any).globalFeescheduleLocality || item.globalFeeScheduleLocality ||
                                              (item as any).globalFeescheduleGPCI || item.globalFeeScheduleGPCI
                                          ),
                                          selectedState: (item as any).globalFeescheduleState || item.globalFeeScheduleState || item.selectedState || null,
                                          selectedLocality: (item as any).globalFeescheduleLocality || item.globalFeeScheduleLocality || item.selectedLocality || null,
                                          selectedGpci: (item as any).globalFeescheduleGPCI || item.globalFeeScheduleGPCI || item.selectedGpci || null,
                                          dateRange: rule.useCustomPaymentDates ? getDefaultDateRange(item.effectiveDate || null, item.expirationDate || null) : getDefaultDateRange(null, null),
                                      };
                                      const result = item?.equator === "in_between"
                                          ? {
                                                ...baseMapping,
                                                startsAt: item?.value.split("&")[0],
                                                endsAt: item?.value.split("&")[1],
                                            }
                                          : baseMapping;

                                      return result;
                                  })
                                : [{ ...paySplit }],
                        rulePaymentFeeScheduleXRef: rule?.rulePaymentFeeScheduleXRef?.length > 0
                            ? rule.rulePaymentFeeScheduleXRef.map((entry, index) => {
                                const hasGlobalId = entry.globalFeeScheduleId != null;

                                const result = {
                                    feeScheduleId: useGlobal ? null : (entry.feeScheduleId != null ? Number(entry.feeScheduleId) : null),
                                    feeScheduleName: useGlobal
                                        ? (entry?.globalFeeSchedule?.name ?? entry?.feeScheduleName ?? '')
                                        : (entry?.feeSchedule?.name ?? entry?.feeScheduleName ?? ''),
                                    fromDate: asIsoDate(entry.fromDate),
                                    toDate: asIsoDate(entry.toDate),
                                    feescheduleLabelToRateXRefId: useGlobal
                                        ? null
                                        : (entry.feescheduleLabelToRateXRefId != null ? Number(entry.feescheduleLabelToRateXRefId) : null),
                                    payMethodId: entry.payMethodId != null ? Number(entry.payMethodId) : null,
                                    payValue: entry.payValue != null ? Number(entry.payValue) : null,
                                    dosMaxRate: entry.dosMaxRate != null ? Number(entry.dosMaxRate) : null,
                                    rateLabels: entry.feeSchedule?.feescheduleLabelToRateXRef || entry.globalFeeSchedule?.globalFeescheduleLabelToRateXRef || [],
                                    feeSchedule: entry.feeSchedule || null,
                                    globalFeeSchedule: entry.globalFeeSchedule || null,
                                    globalFeeScheduleId: hasGlobalId ? Number(entry.globalFeeScheduleId) : null,
                                    globalFeescheduleLabelToRateXRefId: useGlobal && entry.globalFeeScheduleId
                                        ? (entry.globalFeescheduleLabelToRateXRefId != null ? Number(entry.globalFeescheduleLabelToRateXRefId) : null)
                                        : null,
                                    globalFeeScheduleGPCI: (entry as any).globalFeescheduleGPCI || entry.globalFeeScheduleGPCI || null,
                                    globalFeeScheduleState: (entry as any).globalFeescheduleState || entry.globalFeeScheduleState || null,
                                    globalFeeScheduleLocality: (entry as any).globalFeescheduleLocality || entry.globalFeeScheduleLocality || null,
                                    requiresGlobalConfig: Boolean(
                                        (entry as any).globalFeescheduleState || entry.globalFeeScheduleState ||
                                        (entry as any).globalFeescheduleLocality || entry.globalFeeScheduleLocality ||
                                        (entry as any).globalFeescheduleGPCI || entry.globalFeeScheduleGPCI
                                    ),
                                    selectedRateType: entry.selectedRateType || null,
                                    selectedState: (entry as any).globalFeescheduleState || entry.globalFeeScheduleState || entry.selectedState || null,
                                    selectedLocality: (entry as any).globalFeescheduleLocality || entry.globalFeeScheduleLocality || entry.selectedLocality || null,
                                    selectedGpci: (entry as any).globalFeescheduleGPCI || entry.globalFeeScheduleGPCI || entry.selectedGpci || null,
                                    global_schedule_rate_column: entry.global_schedule_rate_column || null,
                                    dateRange: getDefaultDateRange(entry.effectiveDate || null, entry.expirationDate || null),
                                    payValuePercentage: entry.PayValuePercentage || null,
                                    avgLengthOfStay: entry.AvgLengthOfStay || null,
                                    // Anesthesia fields
                                    useMinutesPerUnit: entry.useMinutesPerUnit || false,
                                    minutesPerUnit: entry.minutesPerUnit || 15,
                                };

                                return result;
                            })
                            : def_rulePaymentFeeScheduleXRef,
                        // NEW: Map fee schedule groups for Schedule pay source
                        ruleFeeScheduleGroupXref: rule.ruleFeeScheduleGroupXref?.length > 0
                            ? rule.ruleFeeScheduleGroupXref.map((group, groupIndex) => ({
                                id: isCopyRule ? null : group.id,
                                // Fee Schedule fields (local OR global, not both)
                                feeScheduleId: useGlobal ? null : group.feeScheduleId,
                                feeScheduleName: useGlobal
                                    ? (group.globalFeeSchedule?.name ?? '')
                                    : (group.feeSchedule?.name ?? ''),
                                feeSchedule: group.feeSchedule || null,
                                feescheduleLabelToRateXRefId: useGlobal ? null : group.feescheduleLabelToRateXRefId,

                                // Global fee schedule fields
                                globalFeeScheduleId: useGlobal ? group.globalFeeScheduleId : null,
                                globalFeescheduleLabelToRateXRefId: useGlobal ? group.globalFeescheduleLabelToRateXRefId : null,
                                globalFeeSchedule: group.globalFeeSchedule || null,
                                globalFeescheduleState: (group as any).globalFeescheduleState || group.globalFeeScheduleState || null,
                                globalFeescheduleLocality: (group as any).globalFeescheduleLocality || group.globalFeeScheduleLocality || null,
                                globalFeescheduleGPCI: (group as any).globalFeescheduleGPCI || group.globalFeeScheduleGPCI || null,

                                // Base rate from group
                                baseRate: group.baseRate,

                                // Rate labels for dropdown
                                rateLabels: group.feeSchedule?.feescheduleLabelToRateXRef
                                    || group.globalFeeSchedule?.globalFeescheduleLabelToRateXRef
                                    || [],

                                // Regional config fields (for UI)
                                requiresGlobalConfig: Boolean(
                                    (group as any).globalFeescheduleState || group.globalFeeScheduleState ||
                                    (group as any).globalFeescheduleLocality || group.globalFeeScheduleLocality ||
                                    (group as any).globalFeescheduleGPCI || group.globalFeeScheduleGPCI
                                ),
                                selectedState: (group as any).globalFeescheduleState || group.globalFeeScheduleState || null,
                                selectedLocality: (group as any).globalFeescheduleLocality || group.globalFeeScheduleLocality || null,
                                selectedGpci: (group as any).globalFeescheduleGPCI || group.globalFeeScheduleGPCI || null,

                                useCustomDates: group.useCustomDates || false,
                                customDateRange: group.useCustomDates && group.customStartDate && group.customEndDate
                                    ? {
                                        startdate: group.customStartDate.slice(0, 10),
                                        enddate: group.customEndDate.slice(0, 10),
                                        relativeFilter: 'custom'
                                    }
                                    : null,

                                // Nested arrays: payment (non-split) OR split
                                rulePaymentFeeScheduleXRef: !rule.useSplitPayment && group.rulePaymentFeeScheduleXRef?.length > 0
                                    ? group.rulePaymentFeeScheduleXRef.map(payment => ({
                                        id: isCopyRule ? null : payment.id,
                                        payMethodId: payment.payMethodId,
                                        payValue: payment.payValue,
                                        dosMaxRate: payment.dosMaxRate,
                                        feeScheduleXrefId: group.id
                                    }))
                                    : [],

                                ruleSplitPaymentXRef: rule.useSplitPayment && group.ruleSplitPaymentXRef?.length > 0
                                    ? group.ruleSplitPaymentXRef.map(split => ({
                                        id: isCopyRule ? null : split.id,
                                        payMethodId: split.payMethodId,
                                        payValue: split.payValue,
                                        equator: split.equator,
                                        value: split.equator === 'in_between'
                                            ? split.value
                                            : split.value,
                                        startsAt: split.equator === 'in_between' ? split.value.split('&')[0] : '',
                                        endsAt: split.equator === 'in_between' ? split.value.split('&')[1] : '',
                                        feeScheduleXrefId: group.id
                                    }))
                                    : []
                            }))
                            : def_ruleFeeScheduleGroupXref,
                        // NEW: Base rate and useBaseRate fields
                        baseRate: rule.baseRate || null,
                        useBaseRate: rule.useBaseRate || false,
                        // Global Fee Schedule regional fields (load from backend)
                        selectedRateType: rule.selectedRateType || null,
                        selectedState: rule.globalFeeScheduleState || rule.selectedState || null,
                        selectedLocality: rule.globalFeeScheduleLocality || rule.selectedLocality || null,
                        selectedGpci: rule.globalFeeScheduleGPCI || rule.selectedGpci || null,
                        global_schedule_rate_column: rule.global_schedule_rate_column || null,
                        // Anesthesia fields
                        useMinutesPerUnit: rule.useMinutesPerUnit || false,
                        minutesPerUnit: rule.minutesPerUnit || 15,
                        useGlobalFsForLesserOf: rule.useGlobalFsForLesserOf || false,
                        lesserOfConfiguration: rule.lesserOfConfiguration?.length > 0 
                            ? rule.lesserOfConfiguration.map((entry, index) => {
                                const hasGlobalId = entry.globalFeeScheduleId != null;

                                const result = {
                                    feeScheduleId: useGlobalFsForLesserOf ? null : (entry.feeScheduleId != null ? Number(entry.feeScheduleId) : null),
                                    feeScheduleName: useGlobalFsForLesserOf
                                        ? (entry?.globalFeeSchedule?.name ?? entry?.feeScheduleName ?? '')
                                        : (entry?.feeSchedule?.name ?? entry?.feeScheduleName ?? ''),
                                    effectiveFrom: entry.effectiveFrom != null ? asIsoDate(entry.effectiveFrom) : null,
                                    effectiveTo: entry.effectiveTo != null ? asIsoDate(entry.effectiveTo) : null,
                                    feescheduleLabelToRateXRefId: useGlobalFsForLesserOf ? null
                                        : (entry.feeScheduleLabelToRateXRefId != null ? Number(entry.feeScheduleLabelToRateXRefId) : null),
                                    lesserOfType: entry.lesserOfType != null ? entry.lesserOfType : null,
                                    percentage: entry.percentage != null ? Number(entry.percentage) : null,
                                    rateLabels: entry.feeSchedule?.feescheduleLabelToRateXRef || entry.globalFeeSchedule?.globalFeescheduleLabelToRateXRef || [],
                                    feeSchedule: entry.feeSchedule || null,
                                    globalFeeSchedule: entry.globalFeeSchedule || null,
                                    globalFeeScheduleId: hasGlobalId ? Number(entry.globalFeeScheduleId) : null,
                                    globalFeescheduleLabelToRateXRefId: useGlobalFsForLesserOf && entry.globalFeeScheduleId
                                        ? (entry.globalFeescheduleLabelToRateXRefId != null ? Number(entry.globalFeescheduleLabelToRateXRefId) : null)
                                        : null,
                                    globalFeeScheduleGPCI: (entry as any).globalFeescheduleGPCI || entry.globalFeeScheduleGPCI || null,
                                    globalFeeScheduleState: (entry as any).globalFeescheduleState || entry.globalFeeScheduleState || null,
                                    globalFeeScheduleLocality: (entry as any).globalFeescheduleLocality || entry.globalFeeScheduleLocality || null,
                                    requiresGlobalConfig: Boolean(
                                        (entry as any).globalFeescheduleState || entry.globalFeeScheduleState ||
                                        (entry as any).globalFeescheduleLocality || entry.globalFeeScheduleLocality ||
                                        (entry as any).globalFeescheduleGPCI || entry.globalFeeScheduleGPCI
                                    ),
                                    selectedRateType: entry.selectedRateType || null,
                                    selectedState: (entry as any).globalFeescheduleState || entry.globalFeeScheduleState || entry.selectedState || null,
                                    selectedLocality: (entry as any).globalFeescheduleLocality || entry.globalFeeScheduleLocality || entry.selectedLocality || null,
                                    selectedGpci: (entry as any).globalFeescheduleGPCI || entry.globalFeeScheduleGPCI || entry.selectedGpci || null,
                                    global_schedule_rate_column: entry.global_schedule_rate_column || null
                                };

                                return result;
                            })
                            : def_lesserOfConfiguration,
                            providerRolePaymentGroupXref:
                                rule?.providerRolePaymentGroupXref?.length > 0
                                    ? rule.providerRolePaymentGroupXref.map(group => {
                                        const hasGlobalId = group.globalFeeScheduleId != null;
                                        const useGlobal = Boolean(group.useGlobalFeeSchedules) || hasGlobalId;

                                        return {
                                            id: group.id ?? null,
                                            payMethodId: group.payMethodId != null ? Number(group.payMethodId) : null,
                                            payValue: group.payValue != null ? Number(group.payValue) : null,
                                            feeScheduleId: useGlobal
                                                ? null
                                                : (group.feeScheduleId != null ? Number(group.feeScheduleId) : null),
                                            feeScheduleName: useGlobal
                                                ? (group?.globalFeeSchedule?.name ?? group?.feeScheduleName ?? '')
                                                : (group?.feeSchedule?.name ?? group?.feeScheduleName ?? ''),
                                            feeSchedule: group.feeSchedule || null,
                                            feeScheduleLabelToRateXRefId: useGlobal
                                                ? null
                                                : (group.feeScheduleLabelToRateXRefId != null
                                                    ? Number(group.feeScheduleLabelToRateXRefId)
                                                    : null),
                                            globalFeeScheduleId: hasGlobalId ? Number(group.globalFeeScheduleId) : null,
                                            globalFeeScheduleLabelToRateXRefId:
                                                useGlobal && hasGlobalId
                                                    ? (group.globalFeeScheduleLabelToRateXRefId != null
                                                        ? Number(group.globalFeeScheduleLabelToRateXRefId)
                                                        : null)
                                                    : null,
                                            globalFeeSchedule: group.globalFeeSchedule || null,
                                            globalFeescheduleState:
                                                group.globalFeeScheduleState || null,
                                            globalFeescheduleLocality:
                                                group.globalFeeScheduleLocality || null,
                                            globalFeescheduleGPCI:
                                                group.globalFeeScheduleGPCI || null,
                                            baseRate: group.baseRate != null ? Number(group.baseRate) : null,
                                            rateLabels:
                                                group.feeSchedule?.feescheduleLabelToRateXRef ||
                                                group.globalFeeSchedule?.globalFeescheduleLabelToRateXRef ||
                                                [],
                                            requiresGlobalConfig: Boolean(
                                                group.globalFeeScheduleState ||
                                                group.globalFeeScheduleLocality ||
                                                group.globalFeeScheduleGPCI
                                            ),
                                            selectedState:
                                                group.globalFeeScheduleState ||
                                                group.selectedState ||
                                                null,
                                            selectedLocality:
                                                group.globalFeeScheduleLocality ||
                                                group.selectedLocality ||
                                                null,
                                            selectedGpci:
                                                group.globalFeeScheduleGPCI ||
                                                group.selectedGpci ||
                                                null,
                                            useGlobalFeeSchedules: useGlobal,
                                            global_schedule_rate_column: group.global_schedule_rate_column || null,
                                            dateRange: group.dateRange || null,
                                            providerRolePaymentCriteriaXref:
                                                getDefaultProviderRolePaymentCriteria(
                                                    group.providerRolePaymentCriteriaXref,
                                                    providerRoleCriteria
                                                ),
                                        };
                                    })
                                    : def_providerRolePaymentGroupXref,

                    }
                    return payload;
                }

                return {
                    name: '',
                    ruleTypeId: '',
                    methodId: '',
                    payvalue: '',
                    feeScheduleId: '',
                    feeScheduleName: '',
                    feescheduleLabelToRateXRefId: null,
                    selectedfeescheduleLabelToRateXRef: null,
                    paymethodId: '',
                    gpciLocality: '',
                    contractServiceId: '',
                    description: '',
                    groupIds: [],
                    carveoutCodes: '',
                    codeServiceId: '',
                    paySourceId: '',
                    usePaidCode: false,
                    useMultiProcedurePercent: false,
                    multiProcedurePercents: [
                        multiProcedureTemplate,
                    ],
                    useNpiRate: false,
                    ruleToNpirateXref: [npiRateTemplate],
                    useNpiRole: false,
                    ruleToNpiroleXref: [npiRoleTemplate],
                    precedence: "",
                    payInAddition: false,
                    fromDate: null,
                    toDate: null,
                    isCircuitBreaker: false,
                    lesserOf: false,
                    maxRate: false,
                    codeSelectionType: "Codes",
                    grouperConfigurationId: null,
                    usePaymentFeeSchedules: false,
                    useGlobalFeeSchedules: false,
                    maxRateValue: '',
                    threshold: false,
                    thresholdValue: '',
                    applyAt: 'Charge',
                    useModifiers: false,
                    ruleToModifierXref: [modifierTemplate],
                    ruleSelectionCriteriaXref: [selectionCriteriaTemplate],
                    ignoreClaim: false,
                    considerFsTc: false,
                    dosMaxRate: '',
                    ignoreCmsConfiguration: false,
                    isSometimesPay: false,
                    sometimesPayCodes: '',
                    isCriteriaOperatorAnd: true,
                    useSplitPayment:false,
                    payValuePercentage: '',
                    isAlosEnabled: false,
                    avgLengthOfStay: '',
                    ruleSplitPaymentXref: [{
                        ...paySplit
                    }],
                    rulePaymentFeeScheduleXRef: def_rulePaymentFeeScheduleXRef,
                    // NEW: Fee schedule groups (new schema)
                    ruleFeeScheduleGroupXref: def_ruleFeeScheduleGroupXref,
                    baseRate: null,
                    useBaseRate: false,
                    // Global Fee Schedule fields (Phase 2/3 - Mock Data)
                    selectedRateType: null,
                    selectedState: null,
                    selectedLocality: null,
                    selectedGpci: null,
                    global_schedule_rate_column: null,
                    // Anesthesia fields
                    useMinutesPerUnit: false,
                    minutesPerUnit: 15,
                    lesserOfConfiguration: def_lesserOfConfiguration,
                    providerRolePaymentGroupXref: def_providerRolePaymentGroupXref
                }
            }
        )

        return (state: any, props: any) => ({
            contract: selectContract(state, props),
            directoryId:props?.match?.params?.directoryId,
            //create dashboard
            rulesCreatePending: state.rules.create.pending,

            // update dashboard
            rulesUpdatePending: state.rules.update.pending,
            rulesGetPending: state.rules.get.pending,

            //codeservices
            codeServicesTinyPending: state.services.getTiny.pending,

            //validation
            rulesValidateCodesPending: state.rules.validateCodes.pending,
            rulesValidateCodesError: state.rules.validateCodes.error,
            rulesValidateCodesErrorMessage: state.rules.validateCodes.errorMessage,

            //criteria:
            ruleCriteria: selectRuleCriteria(state),

            // edit
            rule: selectRule(state, props),
            initialValues: selectInitialValues(state, props),
            mode: selectMode(state, props),
            contractId: selectContractId(state, props),
            serviceId: selectServiceId(state, props),
            serviceType: serviceType(state, props),
            ruleId: selectRuleId(state, props),
            ruleTypes: selectRuleTypes(state, props),
            methodTypes: selectMethodTypes(state, props),
            feeSchedules: selectSortedFeeSchedule(state, props),
            feeScheduleLabels: selectSortedFeeScheduleLabels(state, props),
            payMethods: selectPayMethods(state, props),
            selectedServerGroups: selectSelectedGroups(state, props),
            codeServices: selectFilteredCodeServices(state, props),
            paySources: selectPaySources(state, props),
            multiprocPrecedences: selectMultiprocPrecedences(state, props),
            modifiers: selectModifiers(state),
            modifiersPayMethods: selectModifersPayMethod(state),
            isRateExist: state.feeScheduleItems.isRateExist,
            getFeescheduleRateLabelPending: state.feeScheduleItems.getFeeScheduleLabelRate.pending,
            getFeescheduleLabelsPending: state.contracts.feeScheduleLabelsList.pending,
            getFeeScheduleItemsPending: state.contracts.feeScheduleList.pending,
            isViewOnly:selectViewOnlyWithAccess(state,props),
            paySplit:paySplit,
            def_rulePaymentFeeScheduleXRef: def_rulePaymentFeeScheduleXRef,
            npiRoles: state.npiRoles.data,
            dischargeStatusCodes: state.rules.dischargeStatusCodes,
            isFeeScheduleDrgData: state.contracts.isFeeScheduleDrg.data,
            isCodeServiceDrgData: state.contracts.isCodeServiceDrg.data,
            canAccessCMS: selectCanAccessCMS(state as never) || false,
            providerRoleCriteria: selectProviderRoleCriteria(state),
            grouperConfigs: selectGrouperConfigurations(state, props),
        });
    },
    (dispatch) => ({
        actions: bindActionCreators({
            ruleCreate: create,
            ruleUpdate: update,
            ruleGet: get,
            ruleGetMethodTypes: getMethodTypes,
            ruleGetTypes: getRuleTypes,
            ruleGetPayMethods: getPayMethods,
            ruleErrorReset: errorReset,
            contractFeeScheduleList: listFeeSchedule,
            codeServicesListTiny: tiny,
            ruleGetPaySources: getPaySources,
            ruleGetMultiPrecedences: getMultiPrecedences,
            getContract: getContract,
            ruleCodesValidate: validate,
            getModifiers: modifiersLanding,
            getModifiersPayMethods: getModifiersPayMethods,
            getRuleCriteria: getRuleCriteria,
            resetCodesValidate: resetCodesValidate,
            getFeeScheduleLabels: feeScheduleLabelsTiny,
            getFeescheduleRateLabel: getFeescheduleRateLabel,
            getNpiRoles:npiRolesLanding,
            getDischargeStatusCodes: getDischargeStatusCodes,
            getFeeSchedule: getFeeschedule,
            isFeeScheduleDrg: isFeeScheduleDrg,
            isCodeServiceDrg: isCodeServiceDrg,
            getProviderRoleCriteria: getProviderRoleCriteria,
            getGrouperConfigs: getGrouperConfigs,
        }, dispatch)
    })
)(injectIntl(RulesEditPageComponent));
